import script from "./AddKontrakPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddKontrakPage.vue?vue&type=script&setup=true&lang=js"

import "./AddKontrakPage.vue?vue&type=style&index=0&id=276116ec&lang=css"

const __exports__ = script;

export default __exports__